import Normalize from './normalize'
import Proxy from './proxy'
import Read from './csrf/read'
import Retry from './csrf/retry'
import Write from './csrf/write'
import Backbone from '@polleverywhere/backbone'

/**
 * Chain is a singleton. This holds reference to the one global instance that
 * will be returned from the constructor and used by all consumers.
 * @type {Chain}
 */
let instance

/*
* `ajaxes` should be clases that can be instantiated by passing an ajax method
* to the constructor. The objects that are returned must have an ajax method.
* `current` is the actual `ajax`. Usually this will be `$.ajax`.
* Returns an ajax function that is the chain of all the passed in arguments.
*/
function ajaxChain (cache, ...rest) {
  const adjustedLength = Math.max(rest.length, 1)
  const ajaxes = rest.slice(0, adjustedLength - 1)
  let current = rest[adjustedLength - 1]

  while (ajaxes.length) {
    const Next = ajaxes.pop()
    current = (new Next(cache, current)).ajax
  }
  return current
}

// @namespace Ajax
export default class Chain {
  /**
   * @param {boolean} singleton True by default, this class is meant to be used
   * as a singleton by all consumers. But for testing purposes, we need a way to
   * test against fresh new instances each time.
   */
  constructor (options = {}) {
    const { singleton = true } = options

    // Make this a singleton by returning the instance if it's already created.
    if (instance && singleton) return instance
    instance = this

    this.cache = {}
    this.ajax = ajaxChain(
      this.cache,
      Normalize,
      Proxy,
      Read,
      Write,
      Retry,
      Backbone.$.ajax // just a plain ajax method, not a class that can be instantiated.
    )
    // For debugging/testing only
    /* eslint-disable no-undef */
    if (typeof jasmine !== 'undefined' && jasmine !== null) { this.ajax.chain = this }
    /* eslint-enable no-undef */
  }
}
